import type { ValidationIssue } from '../../../utils/vacationRules';

export interface RuleIssuesPanelProps {
    errors: ValidationIssue[];
    warnings: ValidationIssue[];
}

export function RuleIssuesPanel({ errors, warnings }: RuleIssuesPanelProps) {
    if (errors.length === 0 && warnings.length === 0) return null;

    return (
        <div className="space-y-3">
            {errors.length > 0 && (
                <div className="rounded-xl border border-red-200 bg-red-50 p-4" role="alert">
                    <p className="text-sm font-medium text-red-800 font-montserrat">
                        Ajuste necessário antes de enviar
                    </p>
                    <ul className="mt-2 list-disc space-y-1 pl-5">
                        {errors.map((issue) => (
                            <li key={issue.code} className="text-sm text-red-700 font-montserrat">
                                {issue.message}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {warnings.length > 0 && (
                <div className="rounded-xl border border-amber-200 bg-amber-50 p-4" role="status">
                    <p className="text-sm font-medium text-amber-900 font-montserrat">
                        Pontos de atenção
                    </p>
                    <ul className="mt-2 list-disc space-y-1 pl-5">
                        {warnings.map((issue) => (
                            <li key={issue.code} className="text-sm text-amber-700 font-montserrat">
                                {issue.message}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default RuleIssuesPanel;
